<!-- TEMPLATE -->
<template>
  <div class="content" style="padding-top: 0px">
    <v-alert
      v-model="alertError"
      dismissible
      dense
      text
      type="error"
      border="left"
      elevation="2"
      icon="mdi-alert-circle"
    >
      There was an error. Please try again
    </v-alert>
    <v-row>
      <v-col lg="12">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Billing Details</h5>
          </div>
          <div class="card-body">
            <v-row>
              <v-col lg="12">
                <label>Company name</label>
                <input
                  type="text"
                  class="form-control"
                  disabled
                  style="color: white"
                  v-model="customerName"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col lg="12">
                <label>Company address</label>
                <input
                  type="text"
                  class="form-control"
                  disabled
                  style="color: white"
                  v-model="companyAddress"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col lg="12">
                <label>Invoicing contact</label>
                <input
                  type="text"
                  class="form-control"
                  disabled
                  style="color: white"
                  v-model="invoicingContact"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-card color="#272a3d" dark width="100%">
      <v-card-title>
        Subscriptions
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :expanded.sync="expanded"
        :headers="columns"
        :items="subscriptions"
        :search="search"
        show-expand
        class="mytable"
      >
        <!-- template for a colomn -->

        <template v-slot:[`item.status`]="{ item }">
          <v-chip v-if="item.status == 'active'" color="success">{{
            item.status
          }}</v-chip>
          <v-chip v-else-if="item.status == 'trialing'" color="primary">{{
            item.status
          }}</v-chip>
          <v-chip v-else-if="item.status == 'expired'" color="danger">{{
            item.status
          }}</v-chip>
          <v-chip v-else>{{ item.status }}</v-chip>
        </template>

        <template v-slot:[`item.created`]="{ item }">
          <v-chip>{{ item.created | toReadableDate }}</v-chip>
        </template>

        <template v-slot:[`item.current_period_end`]="{ item }">
          <v-chip>{{ item.current_period_end | toReadableDate }}</v-chip>
        </template>

        <template v-slot:[`item.getCountry`]="{ item }">
          {{ item.geolocation | getCountry }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mr-2" @click="showSubscriptions(item.id)">
            mdi-arrow-right-bold-circle-outline
          </v-icon>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          {{ getInvoicesDetails(item.id) }}
          <td :colspan="headers.length">
            <v-row>
              <v-col>
                <!--
             <div class="card">
                <div class="card-header">
                  <h4 class="title">Pricing</h4>
                </div>
                <div class="card-body">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Billed</th>
                          <th>Price</th>
                          <th>Created</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in item.items.data" :key="item.id">
                          <td>{{ item.id }}</td>
                          <td>{{ item.plan.interval }}</td>
                          <td>
                              <money-format :value='item.price.unit_amount'
                                :locale="en"
                                :currency-code="item.price.currency"
                                :subunits-value=true 
                                >
                              </money-format>
                          </td>
                          <td>{{ getReadableDate(item.created) }}</td>
                          <td>{{ item.price.type }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
          <v-col>
             <div class="card">
                <div class="card-header">
                  <h4 class="title">Invoices</h4>
                </div>
                <div class="card-body">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Invoice number</th>
                          <th>Amount</th>
                          <th>Due</th>
                          <th>Created</th>
                        </tr>
                      </thead>
                      <tbody>
                        
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </div>

              -->

                <v-card class="mx-auto my-12" color="#2e2e40">
                  <v-card-title color="black"
                    >Subscription details</v-card-title
                  >

                  <v-card-text color="black">
                    <v-row align="center" class="mx-0"> </v-row>
                  </v-card-text>

                  <v-divider class="mx-4"></v-divider>

                  <v-card-title>Pricing</v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Billed</th>
                            <th>Price</th>
                            <th>Created</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in item.items.data" :key="item.id">
                            <td>{{ item.plan.metadata.name }}</td>
                            <td>{{ item.plan.interval }}</td>
                            <td>
                              <money-format
                                :value="item.price.unit_amount"
                                :locale="en"
                                :currency-code="item.price.currency"
                                :subunits-value="true"
                              >
                              </money-format>
                            </td>
                            <td>{{ getReadableDate(item.created) }}</td>
                            <td>{{ item.price.type }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>

                  <v-divider class="mx-4"></v-divider>

                  <v-card-title>Invoices</v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Invoice Number</th>
                            <th>Amount Due</th>
                            <th>Amount Paid</th>
                            <th>Status</th>
                            <th>Created</th>
                            <th>Due</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in invoices[item.id]" :key="item.id">
                            <td>{{ item.number }}</td>
                            <td>
                              <money-format
                                :value="item.amount_due"
                                :locale="en"
                                :currency-code="item.currency"
                                :subunits-value="true"
                              >
                              </money-format>
                            </td>
                            <td>
                              <money-format
                                :value="item.amount_paid"
                                :locale="en"
                                :currency-code="item.currency"
                                :subunits-value="true"
                              >
                              </money-format>
                            </td>
                            <td>
                              <v-chip
                                v-if="item.status == 'paid'"
                                color="success"
                                >{{ item.status }}</v-chip
                              >
                              <v-chip
                                v-if="item.status == 'open'"
                                color="primary"
                                >{{ item.status }}</v-chip
                              >
                            </td>
                            <td>{{ getReadableDate(item.created) }}</td>
                            <td>{{ getReadableDate(item.due_date) }}</td>
                            <td>
                              <a v-bind:href="item.invoice_pdf" target="_blank">
                                <v-icon class="mr-2"> mdi-download </v-icon>
                              </a>
                              <a
                                v-bind:href="item.hosted_invoice_url"
                                target="_blank"
                              >
                                <v-icon class="mr-2">
                                  mdi-credit-card-outline
                                </v-icon>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>

                  <v-card-text>
                    <v-chip-group
                      v-model="selection"
                      active-class="deep-purple accent-4 white--text"
                      column
                    >
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>


<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
import DomainListDropdown from "./DomainListDropdown.vue";
import MoneyFormat from "vue-money-format";
export default {
  name: "Billing",
  data: function () {
    return {
      columns: [
        { text: "Product", value: "id", sortable: true, align: "start" },
        { text: "Status", value: "status", sortable: true, align: "start" },
        { text: "Created", value: "created", sortable: true, align: "start" },
        {
          text: "Renewed on",
          value: "current_period_end",
          sortable: true,
          align: "start",
        },
        {
          text: "Billing",
          value: "collection_method",
          sortable: true,
          align: "start",
        },
        { text: "Details", value: "data-table-expand" },
      ],
      expanded: [],
      subscriptions: [],
      invoices: "",
      alertError: false,
      alertSuccess: false,
      userInfo: this.$store.state.cognitoInfo,
      customerName: "",
      email: "",
      companyAddress: "",
      licenseNumber: "",
      licenseExpiryDate: "",
      billingPeriod: "",
      price: 0,
      total: 0,
      nextPayment: "",
      invoicingContact: "",
      invoices: [],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {},
  methods: {
    fetchData() {
      PhishingApi.getCustomers()
        .then((response) => {
          this.customerName = response["name"];
          this.invoicingContact = response["email"];
          this.companyAddress =
            response["address"]["city"] +
            " " +
            response["address"]["country"] +
            " " +
            response["address"]["line1"] +
            " " +
            response["address"]["postal_code"];
        })
        .catch(function (error) {
          console.log(error);
        });

      PhishingApi.getSubscriptions()
        .then((response) => {
          console.log(response.data);
          this.subscriptions = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getInvoicesDetails: function (subscription) {
      let self = this;
      PhishingApi.getInvoices(subscription)
        .then((response) => {
          self.invoices[subscription] = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    formattedCurrencyValue: function (currency) {
      return parseFloat(currency);
    },

    getReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    changeStatus(status) {
      this.email_notifications = status;
    },

    selectOption(selected) {
      this.defaultDomainIndex = this.domains.indexOf(selected);
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
  },
  components: {
    DomainListDropdown,
    "money-format": MoneyFormat,
  },
};
</script>

<!-- Style -->
<style>
</style>